import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./searcher.scss";

const Searcher = ({ value, placeholder, handledChange, buttonText }) => {
  return (
    <div className="searcher-container">
      <input
        type="string"
        placeholder={placeholder}
        value={value}
        onChange={handledChange}
      />
      <div className="button-searcher">
        <FontAwesomeIcon icon="search" />
        <span>{buttonText}</span>
      </div>
    </div>
  );
};

Searcher.defaultProps = {};
Searcher.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  handledChange: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
};

export default Searcher;
